import { IAnalyticsEventRole, IAnalyticsRoleArgument } from './types';
import { getRoleEventProperties } from './utils';

export const roleCreated = (
  role: IAnalyticsRoleArgument,
): IAnalyticsEventRole => {
  return {
    eventName: 'Role Created',
    ...getRoleEventProperties(role),
  };
};

export const roleUpdated = (
  role: IAnalyticsRoleArgument,
): IAnalyticsEventRole => {
  return {
    eventName: 'Role Updated',
    ...getRoleEventProperties(role),
  };
};
